import { render, staticRenderFns } from "./tableItemTitle.vue?vue&type=template&id=db435a0a&scoped=true"
import script from "./tableItemTitle.vue?vue&type=script&lang=js"
export * from "./tableItemTitle.vue?vue&type=script&lang=js"
import style0 from "./tableItemTitle.vue?vue&type=style&index=0&id=db435a0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db435a0a",
  null
  
)

export default component.exports